import { odata } from '../../conf';
import Actions from '../../odata/actions';

const actions = new Actions('processCheckSheet', 'processCheckSheets');

const customActions = {
  async LOAD_processCheckSheets({ rootGetters, commit }) {
    const data = await odata.o(rootGetters)
      .get('processCheckSheets')
      .query({
        $filter: 'isDeleted eq false AND status ne null',
        $expand: 'StockItem',
      });
    commit('SET_processCheckSheets', data);
    return data;
  },
  async LOAD_processCheckSheetByStockItem({ rootGetters, commit }, stockItemId) {
    const data = await odata.o(rootGetters)
      .get('processCheckSheets')
      .query({
        $filter: `stockItemId eq ${stockItemId} AND isDeleted eq false`,
      });
    commit('SET_processCheckSheet', data);
    return data;
  },
};

export default { ...actions, ...customActions };
